export const ConfigBase = {
    //baseUrl: 'https://dgc-san-marino-test.azurewebsites.net/'
};
